import { ApiError, ValidationError } from '../types/errors';
import Logger from './logger';

export function createValidationError(field: string, message: string): ValidationError {
  return {
    code: 'VALIDATION_ERROR',
    message,
    severity: 'warning',
    field,
    suggestion: 'Please check the input value and try again.',
  };
}

export function logError(error: ApiError): void {
  const logData = {
    code: error.code,
    message: error.message,
    details: error.details,
    timestamp: new Date().toISOString(),
  };

  switch (error.severity) {
    case 'error':
      Logger.error('API Error:', logData);
      break;
    case 'warning':
      Logger.warn('API Warning:', logData);
      break;
    case 'info':
      Logger.info('API Info:', logData);
      break;
  }
}
